module.exports = __webpack_public_path__ + "static/media/closeMenu.cc5521ac.svg";